export default {
  loadLogoProviderConfirmation (state, payload) {
    state.logoProviderConfirmation = payload.logo
    state.loadingConfirmation = false
  },
  toggleLoadingConfirmation (state, value) {
    state.loadingConfirmation = value
  },
  setScheduleDetails (state, value) {
    state.details = value
  }
}



// WEBPACK FOOTER //
// ./src/store/hotsite/confirmacao/mutations.js